<template>
  <div>
    <md-dialog
      :md-active.sync="isAddEmployee"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title class="dialogTitle"
        >Chọn nhân viên có thể truy cập</md-dialog-title
      >
      <div class="bodyDialog md-layout md-alignment-center-left">
        <div class="md-layout-item md-size-30 md-xsmall-size-100">
          <md-field>
            <label>Vai trò nhân viên</label>
            <md-select v-model="filterPermission">
              <md-option value="Tất cả vai trò">Tất cả vai trò</md-option>
              <md-option value="Nhân viên bán hàng"
                >Nhân viên bán hàng</md-option
              >
              <md-option value="Cộng tác viên">Cộng tác viên</md-option>
            </md-select>
          </md-field>
        </div>
      </div>
      <md-content class="bodyDialog table-products md-scrollbar">
        <table class="custom-table">
          <thead>
            <tr>
              <th>STT</th>
              <th>Mã nhân viên</th>
              <th>Tên nhân viên</th>
              <th>Ảnh đại diện</th>
              <th>Vai trò</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in queriedData" :key="index">
              <td>
                {{ listEmployee.indexOf(item) + 1 }}
              </td>
              <td>{{ item.employeeCode }}</td>
              <td>{{ item.name }}</td>
              <td class="text-center">
                <div class="image-container">
                  <img :src="item.avatar.url" class="box-image" />
                </div>
              </td>
              <td>{{ item.permission }}</td>
              <td>
                <md-checkbox
                  :value="item.employeeCode"
                  v-model="selected"
                ></md-checkbox>
              </td>
            </tr>
          </tbody>
        </table>
      </md-content>
      <md-dialog-actions>
        <md-button class="md-danger md-dense" @click="closeDialog()"
          >Đóng</md-button
        >
        <md-button class="md-success md-dense" @click="conpleteSelect()"
          >Xong</md-button
        >
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>
<script>
export default {
  props: ["isAddEmployee", "listEmployee", "employeeSelected"],
  data() {
    return {
      filterPermission: "Tất cả vai trò",
      selected: [],
    };
  },
  created() {
    this.selected = JSON.parse(JSON.stringify(this.employeeSelected));
  },
  computed: {
    queriedData() {
      let result = [...this.listEmployee];
      if (this.filterPermission === "Cộng tác viên") {
        result = result.filter((item) => {
          return item.permission === "Cộng tác viên";
        });
      } else if (this.filterPermission === "Nhân viên bán hàng") {
        result = result.filter((item) => {
          return item.permission === "Nhân viên bán hàng";
        });
      }
      return result;
    },
  },
  methods: {
    onSelect(items) {
      this.selected = items;
    },
    conpleteSelect() {
      this.$emit("conpleteSelect", this.selected);
    },
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>
<style scoped>
.bodyDialog {
  margin: 0px 50px;
  max-height: 45vh;
  overflow: auto;
}
.table-products {
  border: solid rgba(0, 0, 0, 0.178) 1px;
  border-radius: 10px;
}

.image-container {
  display: inline-block;
  position: relative;
  width: 60px;
  height: 60px;
  overflow: hidden;
  border-radius: 50%;
  background: white;
}
.box-image {
  width: auto;
  height: 100%;
}
.dialogTitle {
  text-align: center;
  width: 40vw;
}
</style>
